import teamSetupPickerStore from "../store/store";
import { mutatorAction } from "satcheljs";

export default mutatorAction('SET_SHOW_STEP_INDICATOR', function setShowStepIndicator(show: boolean) {
    teamSetupPickerStore.showStepIndicator = show;
});
